import { z } from 'zod'

import { type Client } from '@mondough/public-api-request'

import type { CopyBundleResponse, OAuthClient } from '../types'

export function getClientToken(api: Client, clientDetails: OAuthClient) {
  return api
    .url('/oauth2/token')
    .formUrl({
      grant_type: 'client_credentials',
      client_id: clientDetails.clientId,
      client_secret: clientDetails.clientSecret,
    })
    .post()
    .json(
      z.object({
        access_token: z.string(),
        expires_in: z.number(),
      }).parse,
    )
}

export function getCopyBundle(
  api: Client,
  bundleId: string,
  accessToken: string,
) {
  return api
    .url(`/copy/bundle/${bundleId}`)
    .headers({ Authorization: `Bearer ${accessToken}` })
    .get()
    .json<CopyBundleResponse>(
      z
        .object({
          bundle: z.record(
            z.object({ localized_messages: z.record(z.unknown()) }),
          ),
          runtime_overlay_version: z.string(),
          updated_timestamp: z.string(),
        })
        .transform(
          (data): CopyBundleResponse => data as unknown as CopyBundleResponse,
        ).parse,
    )
}
